module.exports = __webpack_public_path__ + "img/rule_bg.1775439203884.png";